import React from 'react'

import FormField, { FormlessFormField } from '../FormField'

export default class ReadonlyFormField extends React.PureComponent<any> {
	render() {
		const { value, formless } = this.props
		const props = { ...this.props }
		props.readonly = true

		delete props.value
		delete props.formless

		const FF = formless ? FormlessFormField : FormField

		return (
			<FF name={props.name || 'readonly'} {...props}>
				{value}
			</FF>
		)
	}
}
